// extracted by mini-css-extract-plugin
module.exports = {"section_wrapper":"gWTrK","photowidget":"SHR1w"};